var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookigStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.7292 22.3333H1.77083V0.270833C1.77083 0.121875 1.64896 0 1.5 0H0.270833C0.121875 0 0 0.121875 0 0.270833V23.5625C0 23.7115 0.121875 23.8333 0.270833 23.8333H25.7292C25.8781 23.8333 26 23.7115 26 23.5625V22.6042C26 22.4552 25.8781 22.3333 25.7292 22.3333ZM5.41667 18.6875H6.5C6.64896 18.6875 6.77083 18.5656 6.77083 18.4167V13.5417C6.77083 13.3927 6.64896 13.2708 6.5 13.2708H5.41667C5.26771 13.2708 5.14583 13.3927 5.14583 13.5417V18.4167C5.14583 18.5656 5.26771 18.6875 5.41667 18.6875ZM10.5625 18.6875H11.867C12.0159 18.6875 12.1378 18.5656 12.1378 18.4167V7.58333C12.1378 7.43437 12.0159 7.3125 11.867 7.3125H10.5625C10.4135 7.3125 10.2917 7.43437 10.2917 7.58333V18.4167C10.2917 18.5656 10.4135 18.6875 10.5625 18.6875ZM15.7083 18.6875H17C17.149 18.6875 17.2708 18.5656 17.2708 18.4167V10.224C17.2708 10.075 17.149 9.95312 17 9.95312H15.7083C15.5594 9.95312 15.4375 10.075 15.4375 10.224V18.4167C15.4375 18.5656 15.5594 18.6875 15.7083 18.6875ZM20.8542 18.6875H22C22.149 18.6875 22.2708 18.5656 22.2708 18.4167V4.875C22.2708 4.72604 22.149 4.60417 22 4.60417H20.8542C20.7052 4.60417 20.5833 4.72604 20.5833 4.875V18.4167C20.5833 18.5656 20.7052 18.6875 20.8542 18.6875Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookigStats);
export default __webpack_public_path__ + "static/media/bookig-stats.7df6067935802ebeb928053cd4d14554.svg";
export { ForwardRef as ReactComponent };